var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSriLanka(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.76076e-05 3.47818H-3.05176e-05V36.5216H4.76076e-05V20V3.47818Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 39.9998C31.0454 39.9998 39.9997 31.0455 39.9997 19.9998C39.9997 8.95417 31.0454 -0.00012207 19.9998 -0.00012207C8.9541 -0.00012207 -0.000183105 8.95417 -0.000183105 19.9998C-0.000183105 31.0455 8.9541 39.9998 19.9998 39.9998Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6523 3.47818H8.72768C8.42081 3.68795 8.12049 3.90631 7.8262 4.13232L6.08705 19.9999L7.8262 35.8674C8.12049 36.0935 8.42081 36.3118 8.72768 36.5215H15.6523V3.47818Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57764e-05 20C4.57764e-05 26.4645 3.06786 32.2115 7.82616 35.8676V4.13242C3.06786 7.78852 4.57764e-05 13.5356 4.57764e-05 20V20Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1739 12.1924V12.6928L32.1925 12.6956L32.1739 12.1924Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4059 25.2173H34.6377L33.0436 26.9564V30.4347H29.5653V28.6956H31.3044V25.2173H23.4783V27.3912H21.7392V23.2481C21.2056 22.7705 20.8696 22.0767 20.8696 21.3042V9.99991C20.8696 8.55921 22.0376 7.39124 23.4783 7.39124V23.4782H26.9566L28.15 22.4836C27.9416 21.9871 27.8261 21.4419 27.8261 20.8695V18.2609H25.2174V13.0435H30.4348C30.4348 12.174 31.7392 11.3044 31.7392 11.3044C31.7392 11.3044 33.0436 12.1739 33.0436 13.0435V14.3479V18.2609C34.011 18.2724 35.548 18.2474 37.2086 18.2609C36.7723 17.4984 36.5218 16.5937 36.5218 15.6523C36.5218 14.1178 37.1843 12.7383 38.2388 11.7836C36.7188 8.41522 34.2933 5.54318 31.2725 3.47818H18.2609V36.5217H31.2725C34.9459 34.0107 37.7388 30.3067 39.0938 25.9678L38.4059 25.2173Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSriLanka);
export default __webpack_public_path__ + "static/media/sri_lanka.3691a3c0680ca18a5f9b81f568d70964.svg";
export { ForwardRef as ReactComponent };